import { OptionsSectionView } from './section-view';

export function createViewClass({
  subSectionsConfig,
  sectionLabel,
  description,
  model,
  i18n,
  warningMessage,
  helpId,
  hideAdvancedOptions,
}) {
  return class AdvancedOptionsView extends OptionsSectionView {
    initialize({ observable, field }) {
      super.initialize({
        observable,
        field,
        subSectionsConfig,
        sectionLabel,
        description,
        model,
        i18n,
        warningMessage,
        helpId,
        hideAdvancedOptions,
      });
    }
  };
}
